/*
 * @Author: LiGang
 * @Date: 2026-06-06 01:04:51
 * @LastEditors: LG liganglig@outlook.com
 * @LastEditTime: 2026-09-24 14:39:18
 * @FilePath: /chezhu-h5/config/envsetting.js
 * @Description: 
 * 
 * Copyright (c) 2026 by ${git_name_email}, All Rights Reserved. 
 */
// 测试
export const parkcloudServerName = 'https://parkcloud.test.szzcloud.club'
export const payServerName = 'https://paycloud.test.szzcloud.club'
export const couponUrl = 'https://coupon.test.szzcloud.club'
export const emqxServerName = 'wss://parkcloud.test.szzcloud.club'
export const iotServerName = 'https://iot.test.szzcloud.club'
export const cityCloudUrl = 'http://citycloud.test.szzcloud.club'
export const chargeServeUrl = 'https://charge.test.szzcloud.club'
export const reqMqCloudUrl = 'https://reqmqcloud.test.szzcloud.club'

// 生产
// export const parkcloudServerName = 'https://parkcloud.szzcloud.club'
// export const payServerName = 'https://paycloud.szzcloud.club'
// export const couponUrl = 'https://coupon.szzcloud.club'
// export const emqxServerName = 'wss://parkcloud.szzcloud.club'
// export const iotServerName = 'https://iot.szzcloud.club'
// export const cityCloudUrl = 'https://citycloud.nayuntec.cn'
// export const chargeServeUrl = 'https://charge.szzcloud.club'
// export const reqMqCloudUrl = 'https://reqmqcloud.nayuntec.cn'

// 银泰城
// export const serverName = location.origin
// export const parkcloudServerName = serverName + '/prs'
// export const payServerName = serverName
// export const emqxServerName = 'wss://' + location.host
// export const iotServerName = serverName + '/iot'

// export const couponUrl = serverName + '/coupon'
// export const cityCloudUrl = serverName + '/citycloud'
// export const chargeServeUrl = serverName + '/charge'
// export const reqMqCloudUrl = serverName + '/reqmq'

// 展示广告 ‘1’云纵 ‘2’伯斯特 ‘3’P云 ‘4’群蜂
// 必须是字符串 1，2，3，4
export const adFlag = '4'